import React, { createContext, useContext, ReactNode } from 'react';
import type { RelatedEventsData } from '../../RelatedEvents';

export interface AppContextData {
  serverUrl: string;
  stage: string;
  locale: string;
  relatedEvents?: RelatedEventsData | null;
}

interface AppContextType {
  data: AppContextData;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

interface AppContextProviderProps {
  children: ReactNode;
  serverUrl: string;
  stage: string;
  locale: string;
  relatedEvents?: RelatedEventsData | null;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({
  children,
  serverUrl,
  stage,
  locale,
  relatedEvents,
}) => {
  const contextValue: AppContextType = {
    data: {
      serverUrl,
      stage,
      locale,
      relatedEvents,
    },
  };

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppContextProvider');
  }
  return context;
};

export { AppContext };
